import React from 'react';
import { GetNotifiedButton } from '@components/EmailNotifications/GetNotifiedButton';
import { EmptyAudienceSvg } from '@components/icons/Audience/EmptyAudience';

export function EmptyAudience({
  hasSaleStarted,
  userId,
  artistId,
}: {
  hasSaleStarted: boolean | undefined;
  userId: string | undefined;
  artistId: string | undefined;
}) {
  return (
    <div className="flex h-auto w-full min-w-0 flex-col items-center justify-center gap-4 self-stretch overflow-hidden rounded-xl bg-base100 p-10 text-center">
      <EmptyAudienceSvg className="hidden md:block" />
      <div className="flex flex-col items-center justify-center gap-1">
        <span className="font-title text-title-s font-medium text-base900">Be the first</span>
        <span className="font-base text-base-m font-normal text-base600">
          Collect to join the audience
        </span>
      </div>
      {!hasSaleStarted && userId && artistId && (
        <GetNotifiedButton userId={userId} artistId={artistId} type="audience" />
      )}
    </div>
  );
}
